export var SessionType;
(function (SessionType) {
    SessionType["CONTINUOUS"] = "CONTINUOUS";
    /**
     * @deprecated Use MANUAL instead
     */
    SessionType["PLAIN"] = "MANUAL";
    SessionType["MANUAL"] = "MANUAL";
})(SessionType || (SessionType = {}));
//# sourceMappingURL=session-type.enum.js.map